import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getArticles} from "modules/selectors";
import {IPlayer} from "modules/types";
import {getArticlesData, getVideoArticleData} from "modules/utils";
import {NewsArticle} from "./NewsArticle";
import {NewsVideoArticle} from "./NewsVideoArticle";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

interface INews {
	player: IPlayer;
}

export const PlayerNews: FC<INews> = ({player}) => {
	const {i18n} = useTranslation();
	const lang = i18n.language;
	const articles = useSelector(getArticles);
	const playerArticles = getArticlesData(articles, player, lang);
	const videoArticle = getVideoArticleData(player, lang);

	return (
		<Wrapper>
			{videoArticle && <NewsVideoArticle title={videoArticle.title} src={videoArticle.src} />}

			{playerArticles.map((article, i) => (
				<NewsArticle
					key={i}
					title={article.title}
					src={article.src}
					desc={article.desc}
					link={article.link}
				/>
			))}
		</Wrapper>
	);
};
